export default __webpack_public_path__ + "static/media/side-bar-bg.c4bf3e74.png";